<template>
  <div class="companyHeader ub-ac">
    <div class="header-box ub ub-ps pad-t pad-b pad-l pad-r mar-b">
      <div class="box-l">
        <div class="ft30 ft-w pad-b">{{companyInfo.OrgName}}</div>
        <div class="ub ub-ps">
          <div class="pad-r info-l">
            <div>统一社会信用代码：{{companyInfo.OrgCode}}</div>
          </div>
        </div>
      </div>
      <div class="box-r"
           v-if="type == 'base'">
        <div class="ub ub-ar">
          <div class="scoring-box tx-c">
            <div class="i-box">
              <svg-icon icon-class="jcxxdf"
                        class="iconstyle"></svg-icon>
            </div>
            <div>基础信息得分</div>
            <div class="ft20 col-b ft-w">{{scoreInfo.BasicScore}}</div>
            <div class="col-r">含基础分20分</div>
          </div>
          <div class="scoring-box tx-c">
            <div class="i-box">
              <svg-icon icon-class="ndtjbb1"
                        class="iconstyle"></svg-icon>
            </div>
            <div>年度统计报表</div>
            <div class="ft20 col-b ft-w">{{totalData.SubmitTimes == null ? 0 : totalData.SubmitTimes}} / 2 ({{totalData.SubmitTimesScore}} 分)</div>
          </div>
          <div class="scoring-box tx-c">
            <div class="i-box">
              <svg-icon icon-class="fzrbdqk"
                        class="iconstyle"></svg-icon>
            </div>
            <div>负责人绑定情况</div>
            <div class="ft20 col-b ft-w">{{totalData.SuperintendentBind ? '已绑定' : '未绑定'}} ({{totalData.SuperintendentBind ? '1' : '0'}} 分)</div>
          </div>
          <!-- <div class="scoring-box tx-c">
                        <div class="i-box">
                            <svg-icon icon-class="qtglryqk" class="iconstyle"></svg-icon>
                        </div>
                        <div>其他管理人员情况</div>
                        <div class="education ft14">
                            <div>本科及以上<span class="col-b"> {{(totalData.EmployeeOtherUndergraduate * 100).toFixed(2)}}%</span></div>
                            <div>大专及以上<span class="col-b"> {{(totalData.EmployeeOtherSpecialty * 100).toFixed(2)}}%</span></div>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyHeader',
  props: {
    companyInfo: Object,
    scoreInfo: {
      type: Object,
      default: {},
    },
    type: {
      type: String,
      default: '',
    },
    totalData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.companyHeader {
  .header-box {
    box-shadow: 0px 1px 3px 0px rgba($color: #000000, $alpha: 0.1);
    .box-l {
      width: 60%;
      .info-l {
        width: 50%;
        line-height: 26px;
      }
      .info-r {
        width: 50%;
        line-height: 26px;
      }
    }
    .box-r {
      width: 40%;
      border-left: 1px solid #ddd;
      .scoring-box {
        .i-box {
          vertical-align: middle;
          line-height: 40px;
          .iconstyle {
            font-size: 40px;
            margin: 0 6px;
            color: #ffb11a;
            margin-top: 10px;
            border-radius: 50%;
            background: #efefef;
          }
          img {
            border-radius: 50%;
            border: 1px solid #efefef;
            background: #efefef;
          }
        }
        .education {
          line-height: 20px;
        }
      }
    }
  }
}
</style>
